<template>
  <div class="main-trade">
    <div class="top-section">
      <div class="right-row">
        <div class="top-right-row">
          <selected-coin :coin="data.relatedCoin"
                         :key="$route.params.tradeFrom + + $route.params.tradeTo +  'selected-coin'"/>
        </div>
        <div class="bottom-right-row">
          <trade-table :key="$route.params.tradeFrom + $route.params.tradeTo + 'trade-table'"/>
        </div>
      </div>

      <div class="center-row">
        <div class="top-section">
          <show-select-info-coin :data='data' :key=" data + $route.params.tradeFrom+ $route.params.tradeTo + 'datas'"/>
        </div>
        <div class="trading-view">
          <vue-trading-view
              :key="$route.params.tradeFrom + $route.params.tradeTo+ ''"
              style="height: 292px"
              :options="options"
          />
        </div>
        <div class="buy-and-sell">
          <buy-and-sell :data="data" :key="data +'changeMarket' + $route.params.tradeFrom + $route.params.tradeTo"/>
        </div>
      </div>

      <div class="left-row">
        <user-panel/>
        <deep-trade :key="$route.params.tradeFrom + $route.params.tradeTo+'depth'" :orderBook="orderBook"/>
      </div>
    </div>
    <div class="history-table" :key="$route.params.tradeFrom + $route.params.tradeTo+ 'hisotries'">
      <history-table/>
    </div>
  </div>
</template>

<script>
import SelectedCoin from "./components/selected-coin";
import TradeTable from "./components/trade-table";
import ShowSelectInfoCoin from "./components/show-select-info-coin";
import VueTradingView from 'vue-trading-view/src/vue-trading-view';
import BuyAndSell from "./components/shop/buy-and-sell";
import DeepTrade from "./components/deep-trade";
import HistoryTable from "./components/history-table";
import UserPanel from "./components/user-panel";
import {
  Loop,
  tradeTo,
  tradeFrom,
  precision,
} from '../../lib/reuseableFunction'
import io from "socket.io-client";

export default {
  name: "main-trade",
  components: {
    UserPanel,
    HistoryTable, DeepTrade, BuyAndSell, ShowSelectInfoCoin, TradeTable, SelectedCoin, VueTradingView
  },
  computed: {
    tradeTo,
    tradeFrom,
    precision
  },
  //Coins fack data
  data() {
    return {
      selectCoin: [],
      orderBook: [],
      options: '',
      headercoin: null,
      loading: false,
      toman: true,
      loop: "",
      marketType: "",
      data: {
        marketType: "",
        maxPrice: 0,
        minPrice: 0,
        lastPrice: 0,
        last24HourVolume: 0,
        sellPrice: 0,
        buyPrice: 0,
        last24HourChange: 0,
        relatedCoin: 'BTC',
        socket: '',

      },
    }
  },
  // watch: {
  //   '$route.params.tradeFrom'() {
  //     this.getTradeHeader();
  //     this.socket.off();
  //
  //     const io = require("socket.io-client");
  //     const socket = io("https://socket.vistadev.xyz/socket", {
  //       path: "/vtp",
  //       transports: ["websocket"],
  //       extraHeaders: {
  //         Authorization: this.state.token,
  //       },
  //       upgrade: true,
  //       connected: true,
  //       reconnection: true,
  //       rejectUnauthorized: false,
  //       reconnectionDelayMax: 5000,
  //       randomizationFactor: 0.5,
  //       timeout: 20000,
  //
  //     });
  //
  //     socket.close();
  //     socket.connect();
  //     socket.on("connect", () => {
  //       this.socket.close();
  //
  //       console.log("connected");
  //     });
  //     let marketType = this.tradeFrom + '_' + this.tradeTo;
  //     socket.emit('listener', {marketType: marketType});
  //     socket.on(marketType, (data) => {
  //       let parsedData = JSON.parse(data);
  //       // console.log(parsedData)
  //       this.orderBook =parsedData;
  //     })
  //   },
  //   '$route.params.tradeTo'() {
  //     this.getTradeHeader();
  //
  //     this.socket.close();
  //     const io = require("socket.io-client");
  //     const socket = io("https://socket.vistadev.xyz/socket", {
  //       path: "/vtp",
  //       transports: ["websocket"],
  //       extraHeaders: {
  //         Authorization: this.state.token,
  //       },
  //       upgrade: true,
  //       connected: true,
  //       reconnection: true,
  //       rejectUnauthorized: false,
  //       reconnectionDelayMax: 5000,
  //       randomizationFactor: 0.5,
  //       timeout: 20000,
  //     });
  //     socket.close();
  //     socket.connect();
  //     socket.on("connect", () => {
  //       console.log("connected");
  //     });
  //     let marketType = this.tradeFrom + '_' + this.tradeTo;
  //     socket.emit('listener', {marketType: marketType});
  //     socket.on(marketType, (data) => {
  //       let parsedData = JSON.parse(data);
  //       // console.log(parsedData)
  //       this.orderBook =parsedData;
  //     })
  //     socket.on('disconnect', (reason) => {
  //       console.log("disconnected");
  //     })
  //   }
  // },
  methods: {

    async getTradeHeader() {
      const [res] = await this.$http.get("trades/market-info", {
        params: {
          weeklyDataIncluded: false,
          market_type:
              this.$route.params.tradeFrom + "_" + this.$route.params.tradeTo,
        },
      });
      this.state.marketType = res.content[0].relatedCoin

      this.loading = false;
      if (res) {
        this.data = res.content[0] || this.data;
        this.state.shopInfo.lastPrice = this.data.lastPrice;
        this.state.shopInfo.change24 = this.data.last24HourChange;
        document.title =
            `بازار ${this.$coinLabel[this.tradeFrom]} - ${
                this.$coinLabel[this.tradeTo]
            }` +
            " ｜ " +
            this.$toLocal(this.data.lastPrice, this.precision);
      }
    },
  },
  mounted() {
    this.marketType = this.tradeFrom + '_' + this.tradeTo;
    console.log(this.marketType)
    // this.headercoin = this.coins[1];
    this.loading = true;
    document.title = `بازار ${this.$coinLabel[this.tradeFrom]} - ${
        this.$coinLabel[this.tradeTo]
    }`;
    if (this.state.loop) {
      this.loop = new Loop(
          this.getTradeHeader,
          this.state.time,
          "tradeHeader:" + this.tradeFrom + "-" + this.tradeTo
      );
      this.loop.start();
    } else {
      this.getTradeHeader();
    }
  },


  beforeDestroy() {
    this.loop.stop();
  },
  created() {
    this.options = {
      autosize: false,
      symbol: this.$route.params.tradeFrom != 'TETHER' ? 'BINANCE:' + this.$coinsUnit[this.$route.params.tradeFrom] + 'USDT' : 'BINANCEUS:USDTUSD',
      height: '292px',
      width: '100%',
      timezone: 'Asia/Tehran',
      style: '1',
      theme: 'dark',
      locale: 'fa_IR',
      enable_publishing: true,
      withdateranges: true,
      range: 'ytd',
      hide_side_toolbar: false,
      allow_symbol_change: true,
      enabled_features: [
        'header_fullscreen_button'
      ],
    }
  },
  //   const io = require("socket.io-client");
  //   const socket = io("https://socket.vistadev.xyz/socket", {
  //     path: "/vtp",
  //     transports: ["websocket"],
  //     extraHeaders: {
  //       Authorization: this.state.token,
  //     },
  //     upgrade: true,
  //     connected: true,
  //     reconnection: true,
  //     rejectUnauthorized: false,
  //     reconnectionDelayMax: 5000,
  //     randomizationFactor: 0.5,
  //     timeout: 20000,
  //
  //   });
  //   this.socket = socket;
  //   socket.connect();
  //
  //   socket.on("connect", () => {
  //     console.log("connected");
  //   });
  //
  //   let marketType = this.tradeFrom + '_' + this.tradeTo;
  //
  //   socket.emit('listener', {marketType: marketType});
  //   socket.on(marketType, (data) => {
  //
  //     let parsedData = JSON.parse(data);
  //     this.orderBook =parsedData
  //     console.log(this.orderBook)
  //     console.log(parsedData)
  //   })
  //
  // }
}


</script>

<style lang="scss" scoped>
.main-trade {
  display: flex;
  flex-direction: column;
  background-image: url("../../assets/backgrounds/trade.png");
  background-size: cover;
  background-position: center;
  direction: rtl;
  padding: 0 20px;
  margin-top: -50px;


  .top-section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    color: #FBFBFD;
    margin-top: 5px;
    align-items: flex-start;
    gap: 20px;
    height: 60%;

    .right-row {
      display: flex;
      flex-basis: 200px;
      flex-grow: 1;
      justify-content: center;
      flex-direction: column;
      width: 100%;

      .top-right-row {
        height: 50%;
      }

      .bottom-right-row {
        height: 50%;
      }

    }

    .center-row {
      flex-grow: 2;
      display: flex;
      flex-basis: 340px;
      flex-direction: column;
      gap: 15px;

      .top-section {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 10%;
      }

      .trading-view {
        height: 20%;
      }

      .buy-and-sell {
        height: 70%;
      }
    }

    .left-row {
      display: flex;
      flex-direction: column;
      height: auto;
      flex-grow: 1;
      justify-content: center;
      gap: 25px;
      margin-top: 10px;
      flex-basis: 160px;
    }
  }

  .history-table {
    height: 40%;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}

@media (max-width: 992px) {
  .left-row {
    order: 1;
  }

  .center-row {
    order: 2;
  }

  .right-row {
    order: 3;
  }
}
</style>